import Quill from 'quill';

const Parchment = Quill.import('parchment');

const LineHeight = new Parchment.Attributor.Style(
  'customLineHeight',
  'line-height',
  {
    scope: Parchment.Scope.BLOCK,
  },
);

export default LineHeight;
